// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ziHg","name":"styles_name__2S7zl","phone":"styles_phone__YfS-P"};